import { AppContext } from '../state/index.mjs';
import {useContext} from 'react';

/**
 * @typedef GuideConfigurationsHookValues
 * @property {Object} customConfigs - custom configurations added via database or extra guide config options
 * @property {number} guideId - returns the guide ID for the conversation
 * @property {string} guideType - returns "consumer", "business", or "hybrid" based on guideType
 * @property {boolean} isBranchGuide - true if conversation is a branch guide
 * @property {boolean} isDialogue - true if guide was initialized in a dialogue theme
 * @property {boolean} isMockMode - true if mock service is being used
 * @property {boolean} isRemoteSession - true is this conversation is a remote session
 * @property {Function} isUsingSalesforce - true if using salesforce
 * @property {Function} isDemoMode - true if using salesforce
 * @property {string} runMode - environment run mode
 * @property {Object} salesforceConfig - salesforce configurations
 * @property {Object} uiConfig - ui configuration, used by guide to modify / set style props in the app
 */

/**
 *
 * @returns {GuideConfigurationsHookValues}
 */
const useGuideConfig = () => {
  const appContextState = useContext(AppContext);
  const guideConfigsObj = appContextState.guideConfigurations;
  const { guideId, guideType, isRemoteSession } = appContextState.user || {};
  const isUsingSalesforce = () => !!guideConfigsObj.salesforceConfig; //TODO: this will need more logic to determine if SF is being used

  return {
    ...guideConfigsObj,
    guideId,
    guideType,
    isRemoteSession,
    isUsingSalesforce
  };
};

export { useGuideConfig };
